import React, { Component } from 'react'
import './AboutUs.css'
// let aboutUs = 'Details not available'
class AboutUs extends Component {
    constructor(props) {
        super(props)

        this.state = {
            aboutUs: 'Details not available'
        }
    }

    // componentWillReceiveProps(nextProps){
    //     aboutUs=nextProps.transporter_data.about_us;
    //     if(aboutUs==undefined || aboutUs==null){
    //         aboutUs='Details not available'

    //     }
    // }

    static getDerivedStateFromProps(nextProps, prevState) {
        // aboutUs = nextProps.transporter_data.about_us
        // if(aboutUs==undefined || aboutUs==null){
        //     aboutUs='Details not available'
        // }
        if (nextProps.transporter_data.about_us === undefined || nextProps.transporter_data.about_us === null) {
            return {
                aboutUs: 'Details not available'
            }
        }
        else {
            return {
                aboutUs: nextProps.transporter_data.about_us

            }
        }
    }

    render() {
        const { aboutUs } = this.state
        return (
            <>
                <div className="aucard">
                    <div className="aucontainer row">
                        <div className="col-12">
                            <h3 className="data_header">Market Intelligence</h3>
                        </div>
                        <div className="col-12">
                            <p>{
                                aboutUs
                            }</p>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default AboutUs
